import { Heading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getVehicleFuelTypesList } from "../../data/vehicle";
import { TilesSelectGroup } from "../generic/TileSelectGroup";
import { BrandType } from "@bus/models";
import { capitalizeBrand } from "../../helpers/capitalizeBrand";

export const VehicleFuelType = () => {
    const { t } = useTranslation(["question1page"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getTitle = () => {
        switch (brand) {
            case BrandType.VWN:
                return t("question1page:vehicle-fuel.titleVWN");
            case BrandType.VW:
            case BrandType.AUDI:
            case BrandType.SKODA:
                return t("question1page:vehicle-fuel.titleAlternative", {brand: capitalizeBrand(brand)});
            case BrandType.SEAT:
                return t("question1page:vehicle-fuel.titleSeat");
            case BrandType.CUPRA:
                return t("question1page:vehicle-fuel.titleCupra");
            default:
                return t("question1page:vehicle-fuel.title");
        }
    }
    return (
        <>
            <Heading level={2} className={'u-font-size-fs2'}>{getTitle()}</Heading>

            <TilesSelectGroup
                list={getVehicleFuelTypesList(t)}
                fieldName="fuelTypes"
                className="u-1/3 u-1/2@l u-1/1@s VehicleFuelType"
                required
            />
        </>
    );
};
